/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'status_return': {
    width: 6,
    height: 8,
    viewBox: '0 0 6 8',
    data: '<path pid="0" d="M0 7.181v-.81l.33-.03c.193-.02.29-.113.29-.28v-4.65l-.57-.03v-.85h2.73c.773 0 1.367.144 1.78.43.413.287.62.757.62 1.41 0 .454-.118.827-.355 1.12a2.093 2.093 0 0 1-.845.64c.24.087.43.29.57.61l.72 1.57.57.02v.85H3.37v-.81l.29-.03c.153-.02.23-.08.23-.18a.322.322 0 0 0-.04-.14l-.47-1a.904.904 0 0 0-.245-.355c-.09-.07-.218-.105-.385-.105h-.91v1.74l.65.03v.85H0zm1.84-3.57h.87c.82 0 1.23-.366 1.23-1.1 0-.42-.108-.693-.325-.82-.217-.126-.565-.19-1.045-.19h-.73v2.11z" fill-rule="nonzero"/>'
  }
})
